import { ApiResponse } from "../../../model/common/apiResponse";
import {
  axiosService,
  ServiceEndPoint,
} from "../../../Services/common/Axios.service";
import { lookUpService } from "../../../Services/common/lookup.service";

const SERVICE_URL = ServiceEndPoint.account_service;

export async function fetchAccountList(
  payload: any
): Promise<ApiResponse<any>> {
  const response = await axiosService.post(
    `${SERVICE_URL}accounts/query`,
    payload
  );
  return response.data;
}
export async function getAccountDetails(
  id?: string
): Promise<ApiResponse<any>> {
  const response = await axiosService.get(`${SERVICE_URL}accounts/${id}`);
  return response.data;
}

// Create new Company Account
export async function createNewCompanyAcc(
  payload: any
): Promise<ApiResponse<any>> {
  const response = await axiosService.post(`${SERVICE_URL}accounts/`, payload);
  return response.data;
}

// Update Company account by id
export async function updateAccountById(
  id: any,
  payload: any
): Promise<ApiResponse<any>> {
  const response = await axiosService.put(`${SERVICE_URL}accounts/${id}`,payload);
  return response.data;
}
//Get account details by id
export const getAccountDataById = async (id: string) => {
  const response = await getAccountDetails(id);
  const transformedResponse = {
    ...response.data,
    type: response.data?.type?.code,
    source: response.data?.source?.code,
    environment_type: response.data?.environment_type?.code,
    uom_system: response.data?.uom_system?.code,
    country: response.data?.country?.code,
  };

  return {
    basicInfo: {
      code: transformedResponse?.code,
      name: transformedResponse?.name,
      subscription_amount: transformedResponse?.subscription_amount,
      subscription_users: transformedResponse?.subscription_users,
      subscription_clients: transformedResponse?.subscription_clients,
      subscription_warehouses: transformedResponse?.subscription_warehouses,
      is_active: transformedResponse?.is_active,
      type: transformedResponse?.type,
      source: transformedResponse?.source,
      environment_type: transformedResponse?.environment_type,
    },
    companyAddress: {
      contact_name: transformedResponse?.contact_name,
      time_zone_name: transformedResponse?.time_zone_name,
      address_line_1: transformedResponse?.address_line_1,
      address_line_2: transformedResponse?.address_line_2,
      city: transformedResponse?.city,
      state_province: transformedResponse?.state_province,
      postal_code: transformedResponse?.postal_code,
      country: transformedResponse?.country,
    },
    companyConfig: {
      uom_system: transformedResponse?.uom_system,
      attachments: transformedResponse?.attachments || [],
      links: transformedResponse?.links || [],
      logo: transformedResponse?.logo,
    }
  };
};
//Promise to fetch all the lookups for Basic Info
export const basicInfoLookups = () => {
  const response = Promise.all([
    lookUpService
      .accountTypeLookup()
      .then((response: any) => {
        return response.data.data;
      })
      .catch((error) => {
        return error;
      }),

    lookUpService
      .accountSourceLookup()
      .then((response: any) => {
        return response.data.data;
      })
      .catch((error) => {
        return error;
      }),

    lookUpService
      .getEnvironmentTypes()
      .then((response: any) => {
        return response.data.data;
      })
      .catch((error) => {
        return error;
      }),
  ]);
  return response;
};
// Promise to fetch all the lookups for Address
export const addressLookups = () => {
  const response = Promise.all([
    lookUpService.countryLookup().then((response: any) => {
      return response.data.data;
    }),
    lookUpService.timezoneLookup().then((response: any) => {
      return response.data.data;
    }),
  ]);
  return response;
};
// Promise to fetch all the lookups for Configuration
export const uomLookups = () => {
  const response = Promise.all([
    lookUpService.uomSystemLookup().then((response: any) => {
      return response.data.data;
    }),
  ]);
  return response;
};
